document.addEventListener('DOMContentLoaded', () => {
  const LOCAL_STORAGE_KEY = 'theme_wishlist_items';
  
  // Custom Element for Wishlist Grid
  class WishlistGrid extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('[data-grid]');
      this.emptyState = this.querySelector('[data-empty-state]');
      this.init();
    }

    async init() {
      const items = this.getItems();
      if (items.length === 0) {
        this.showEmptyState();
        return;
      }
      
      this.hideEmptyState();
      this.container.innerHTML = '<div class="loading-spinner">Yükleniyor...</div>';
      
      try {
        const fetchPromises = items.map(handle => 
          fetch(`/products/${handle}?section_id=wishlist-card`)
            .then(res => res.text())
            .then(html => {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = html;
              const card = tempDiv.querySelector('.shopify-section');
              
              if(card && card.innerHTML.trim() !== "") {
                return card.innerHTML;
              }
              // If product not found/deleted, we should probably remove it from list
              this.removeItem(handle);
              return '';
            })
            .catch(e => '')
        );

        const cardsHtml = await Promise.all(fetchPromises);
        this.container.innerHTML = cardsHtml.filter(html => html !== '').join('');
        
        // Setup Grid Togglers
        this.setupTogglers();
        
      } catch (err) {
        console.error('Error fetching wishlist products', err);
        this.container.innerHTML = '<div class="alert alert--error">Ürünler yüklenirken bir hata oluştu.</div>';
      }
    }

    getItems() {
      try {
        return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || [];
      } catch (e) {
        return [];
      }
    }

    removeItem(handle) {
      const items = this.getItems().filter(item => item !== handle);
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items } }));
    }

    showEmptyState() {
      if(this.container) this.container.style.display = 'none';
      if(this.emptyState) this.emptyState.style.display = 'block';
    }

    hideEmptyState() {
      if(this.container) this.container.style.display = 'grid'; // or original display
      if(this.emptyState) this.emptyState.style.display = 'none';
    }

    setupTogglers() {
      const togglers = document.querySelectorAll('[data-layout-toggle]');
      if(!togglers.length) return;
      
      togglers.forEach(btn => {
        btn.addEventListener('click', (e) => {
          togglers.forEach(t => t.classList.remove('is-active'));
          btn.classList.add('is-active');
          const layout = btn.getAttribute('data-layout-toggle');
          if (layout === 'grid') {
            this.container.classList.remove('list-layout');
            this.container.classList.add('grid-layout', 'grid', 'grid-cols-2', 'md:grid-cols-3', 'lg:grid-cols-4', 'gap-4');
          } else {
            this.container.classList.remove('grid-layout', 'grid', 'grid-cols-2', 'md:grid-cols-3', 'lg:grid-cols-4', 'gap-4');
            this.container.classList.add('list-layout', 'flex', 'flex-col', 'gap-4');
          }
        });
      });
    }
  }

  customElements.define('wishlist-grid', WishlistGrid);

  // Global Wishlist Button Logic
  class WishlistButton extends HTMLElement {
    constructor() {
      super();
      this.handle = this.getAttribute('data-product-handle');
      this.btn = this.querySelector('button');
      if(this.btn) {
        this.btn.addEventListener('click', this.toggle.bind(this));
      }
      
      this.updateState();
      window.addEventListener('wishlist:updated', this.updateState.bind(this));
    }

    getItems() {
      try {
        return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || [];
      } catch (e) {
        return [];
      }
    }

    toggle(e) {
      e.preventDefault();
      e.stopPropagation();
      
      let items = this.getItems();
      if (items.includes(this.handle)) {
        items = items.filter(item => item !== this.handle);
        // If we are on wishlist page, we should re-render or remove the card
        const card = this.closest('.product-card');
        if (card && document.querySelector('wishlist-grid')) {
          card.style.opacity = '0';
          setTimeout(() => {
            if(card.parentElement) card.parentElement.remove();
            if(items.length === 0) {
              const grid = document.querySelector('wishlist-grid');
              if(grid) grid.showEmptyState();
            }
          }, 300);
        }
      } else {
        items.push(this.handle);
      }
      
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items } }));
    }

    updateState() {
      const items = this.getItems();
      if (items.includes(this.handle)) {
        this.classList.add('is-active');
        this.setAttribute('title', 'Favorilerden Çıkar');
      } else {
        this.classList.remove('is-active');
        this.setAttribute('title', 'Favorilere Ekle');
      }
    }
  }

  customElements.define('wishlist-button', WishlistButton);
});
